<div class="error-login-container">
    @if (error$ | async; as error) {
        <div class="error-login">
            <div class="error-img">
                <img src="assets/images/common/error-image.svg" width="450px" />
            </div>

            <div class="heading-generic">{{ "authErrors.headingGeneric" | labelsProvider }}</div>

            @switch (errorType) {
                @case (AuthErrorType.notInOrganization) {
                    <div>
                        <div class="heading">{{ "authErrors.headingNotInOrganization" | labelsProvider }}</div>
                        <div class="description description__error">
                            {{ "authErrors.descriptionNotInOrganizationFirstLine" | labelsProvider }} <br />
                            {{ "authErrors.descriptionNotInOrganizationSecondLine" | labelsProvider }}
                        </div>
                    </div>
                }

                @case (AuthErrorType.invitationExpired) {
                    <div>
                        <div class="heading">{{ "authErrors.headingInvitationExpired" | labelsProvider }}</div>
                        <div class="description description__error">
                            {{ "authErrors.descriptionInvitationExpiredFirstLine" | labelsProvider }} <br />
                            {{ "authErrors.descriptionInvitationExpiredSecondLine" | labelsProvider }}
                        </div>
                    </div>
                }

                @case (AuthErrorType.secretExpired) {
                    <div>
                        <div class="heading">{{ "authErrors.headingSecretExpired" | labelsProvider }}</div>
                        <div class="description description__error">
                            {{ "authErrors.descriptionSecretExpiredFirstLine" | labelsProvider }} <br />
                            {{ "authErrors.descriptionSecretExpiredSecondLine" | labelsProvider }}
                        </div>
                    </div>
                }
            }

            <div class="description">
                {{ "authErrors.footerSupport" | labelsProvider }}
                <a href="mailto:support@zenity.io">{{ "authErrors.zenitySupportEmail" | labelsProvider }}</a>
            </div>
        </div>
    }
</div>
